import { MemberRemarksListComponent } from '../../../../../../../shared/member-remarks-list/member-remarks-list.component';
import { PdfDialogComponent } from '@shared/pdf-dialog/pdf-dialog.component';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { MemberDataService } from '../../../members/services/member-data.service';
import { Component, OnInit, Inject, OnDestroy, AfterViewInit, ViewChild, ViewChildren, QueryList, ElementRef, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subscription, forkJoin, BehaviorSubject, of, Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { tap, map, delay, distinctUntilChanged, debounceTime, catchError } from 'rxjs/operators';
import { DepositEntityService } from '../../services/deposit-entity.service';
import { Deposit } from '@core/models/deposit.model';
import Swal from 'sweetalert2';
import { TransactionStatus } from '@core/enums/transaction-status.enum';
import { DepositDataService } from '../../services/deposit-data.service';
import { UploadHttpService } from '@core/services/upload-http.service';
import { TransactionHttpService } from '@core/services/transaction-http.service';
import { OwlDateTimeInputDirective } from '@danielmoncada/angular-datetime-picker';
import { DatePipe } from '@angular/common';
import { MerchantBankHttpService } from '@core/services/merchant-bank-http.service';
import { BankReceiptBrowserDialogComponent } from '@views/pages/apps/settings/bank-receipts/dialogs/bank-receipt-browser/bank-receipt-browser.component';
import { BankReceipt } from '@core/models/bank-receipt.model';
import { BankReceiptDataService } from '@views/pages/apps/settings/bank-receipts/services/bank-receipt-data.service';
import { BankReceiptStatus } from '@core/enums/bank-receipt.enum';
import * as moment from 'moment-timezone';
import { DropdownHttpService } from '@core/services/dropdown-http.service';
import { Lightbox } from 'ngx-lightbox';
import { SystemSettingDataService } from '../../../../superuser/system-setting/services/system-setting-data.service';
import { TimezoneDatePipe } from '@core/pipes/timezone-date.pipe';
import { DateTime } from 'luxon';
import { RequestReceiptDialogComponent } from '@shared/request-receipt-dialog/request-receipt-dialog.component';
import { ViewReceiptComponent } from '../view-receipt/view-receipt.component';
import { UploadReceiptComponent } from '../upload-receipt/upload-receipt.component';
import { AppPermissionService } from '@core/services/app-permission.service';
import { AppState } from '@store/reducers';
import { Store, select } from '@ngrx/store';
import { TransactionCallbackHttpService } from '@core/services/transaction-callback-http.service';
import { Pagination } from '@core/models/pagination.model';
import { Stats } from '@core/enums/stats.enum';
import { DepositStatus } from '@core/enums/deposit-status.enum';
import { PaymentModeDataService } from '@views/pages/apps/settings/payment-mode/services/payment-mode-data.service';
import { DepositApproveComponent } from '../deposit-approve/deposit-approve.component';

type OnSaveDepositActionType = 'approve' | 'reject' | 'void' | 'revert' | 'mark-resolve' | 'force-approve';

declare var $: any;
@Component({
  selector: 'kt-view-deposit-new',
  templateUrl: './deposit-details-new.component.html',
  styleUrls: ['./deposit-details-new.component.scss']
})

export class DepositDetailsNewComponent implements OnInit, OnDestroy, AfterViewInit {
  // expose to template
  DepositStatusEnum = DepositStatus;

  accountName: string;
  bankName: string;
  accountNumber: number;
  searchTerm = new Subject<string>();
  count = 0;

  @ViewChildren('focusfield') focusfield: QueryList<ElementRef>;
  imagePreview = [];
  username = '';
  depositStatus: number;
  depo = {
    ...this.data.deposit
  };

  form: FormGroup;
  @ViewChild(OwlDateTimeInputDirective) datePicker: OwlDateTimeInputDirective<any>;

  status = TransactionStatus;
  statusReceipt = BankReceiptStatus;
  statusCallback = Stats;
  selectedReceipt$ = new BehaviorSubject<BankReceipt[]>(null);
  deposit = {
    newBoUserId: 0
  };
  messages$ = this.depositDataService.messages$;

  isSelectedMerchantBank = false;
  isValidMerchantBank = true;
  paymentAccount = {
    bank_name: '',
    account_number: '',
    account_name: ''
  };

  bankReceiptId: number;
  refreshStatus: boolean;

  dropdownSettings = {};
  paymentAccountDropdownSettings = {};
  eligibleBankAccountDropdownSettings = {};
  paymentModeDropdownSettings = {};
  eligiblePaymentProcessorDropdownSettings = {};
  eligibleBankDropdownSettings = {};
  eligibleCombinedDropdownSettings = {};

  paymentModeDropdownList = [];

  paymentProcessorDropdownList = [];
  paymentProcessorSelectedItems = [];
  bankDropdownList = [];
  bankSelectedItems = [];
  paymentAccountDropdownList = [];
  paymentAccountSelectedItems = [];
  combinedDropdownList = [];
  combinedSelectedItems = [];

  buttonLoading = false;
  isDirectTransfer = false;
  isPG = false;
  isCombined = false;
  uploadReceipt = false;

  currencies = JSON.parse(sessionStorage.getItem('currencies')) === null ? [] : JSON.parse(sessionStorage.getItem('currencies'));
  selectedMember = [];
  receiptList = [];
  isAdmin = JSON.parse(localStorage.getItem('user_data')).is_admin;
  checkValidation = false;
  timezone = this.data.timezone ? this.data.timezone : JSON.parse(localStorage.getItem('user_data')).timezone;
  clientOffset = moment().utcOffset() * 60 * 1000;
  offset = moment.tz(this.timezone).utcOffset() * 60 * 1000;

  bankAccountLoading = false;
  paymentModeLoading = false;
  paymentProcessorLoading = false;
  bankLoading = false;
  combinedLoading = false;

  showTotalProcessingFeeError: boolean = false;
  totalProcessingFeeErrorMessage: string = '';

  showProcessingFeeError: boolean = false;
  processingFeeErrorMessage: string = '';
  cr_totalProcessingFeeErrorMessage: string = '';
  cr_processingFeeErrorMessage: string = '';

  depositReceipts = [];

  selectReceiptAgain: boolean = false;

  pageSize = 8;
  page = 1;
  maxSize = 5;
  transactionCallbackLogsPagination: Pagination;
  transactionCallbackLogs = [];

  depositLimit = null;
  selectedTabIndex: number = 0;

  // permissions
  canEditDeposits: boolean;
  canVoidDepositsBankTransaction: boolean;
  canVoidDepositsPaymentGateway: boolean;
  canRevertDeposits: boolean;
  canResolveUnusualCallback: boolean;
  canViewReceipts: boolean;
  canRequestReceipts: boolean;
  canUploadReceipts: boolean;
  canBrowseReceipts: boolean;
  canBypassBankingDepositLimit: boolean;
  canViewDepositEventHistory: boolean;
  canForceApproveDeposits: boolean;
  canManualResolveDeposit: boolean;

  private subscription = new Subscription();
  private subscriptions = new Subscription();
  private formSubscription = new Subscription();
  private messageSubscription = new Subscription();
  private datePickerSubscription = new Subscription();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { deposit: Deposit, mode: string, timezone: string, is_crypto: number },
    public dialogRef: MatDialogRef<DepositDetailsNewComponent>,
    public dialog: MatDialog,
    private depositEntityService: DepositEntityService,
    private depositDataService: DepositDataService,
    private dropdownHttpService: DropdownHttpService,
    private uploadService: UploadHttpService,
    private datePipe: DatePipe,
    private transactionHttpService: TransactionHttpService,
    private merchantBankHttpService: MerchantBankHttpService,
    private memberDataService: MemberDataService,
    private bankReceiptDataService: BankReceiptDataService,
    private eventEmitterService: EventEmitterService,
    private lightbox: Lightbox,
    private systemSettingService: SystemSettingDataService,
    private timeZoneDate: TimezoneDatePipe,
    private appPermissionService: AppPermissionService,
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>,
    private transactionCallbackHttpService: TransactionCallbackHttpService,
    private paymentModeDataService: PaymentModeDataService
  ) { }

  ngOnInit() {

    if (this.currencies.length === 0) {
      this.dropdownHttpService.currencies.subscribe(res => {
        this.currencies = res;
      });
    }
    if (this.data.mode !== 'create') {
      this.receiptList.push({
        src: this.data.deposit['receipt_path'],
        caption: (this.data.deposit['username'] + ' deposit receipt').toLocaleUpperCase(),
        thumb: this.data.deposit['receipt_path']
      });
    }
    this.formInit();
    if (this.data.mode !== 'create') {
      this.getReceipts();
      this.bankAccountLoading = true;
      this.onFocusField();
      this.eventEmitterService.selectedReceiptSubsVar = this.eventEmitterService.updateSelectedReceipt.subscribe((res) => {
        this.onUpdateSelectedReceipt(res);
      });

      this.bankReceiptInit(this.data.deposit.bank_receipt_id);

      this.paymentModeDataService.getPaymentAccount(`?status[0]=1&status[1]=2&settings_currency_id=${this.depo.currency_id}`).subscribe(
        res => {
          var selectedBank = res.find(v => v.account_number == this.data.deposit.account_number);
          // this.paymentAccountDropdownList = res;
          // Map over the response to add the new column with desired values
          this.paymentAccountDropdownList = res.map(item => ({
            ...item,
            value: [item.id, item.code, item.account_name, item.account_number]  // Add the new column with your desired values
          }));
          this.paymentAccountSelectedItems = selectedBank ? [selectedBank] : [];
          this.bankAccountLoading = false;
      });

      // get PG callback logs
      this.onGetTransactionCallbackLogs();
    } else {
      this.form.get('member_account_id').valueChanges.subscribe(value => {
        this.form.patchValue({ 
          payment_mode_id: null,
          payment_account_id: null,
          payment_gateway_config_id: null,
          payment_processor_id: null 
        });
        this.depositLimit = null;
        $("kt-dropdown-wo-lazyload div angular2-multiselect div div div span.c-remove.clear-all.ng-star-inserted").click();
        if (value === null) {
          this.paymentModeDropdownList = [];
          this.paymentAccountDropdownList = [];
          this.paymentProcessorDropdownList = [];
          this.combinedDropdownList = [];
        } 
      })
    }

    // For create deposit
    this.eligibleBankAccountDropdownSettings = {
      singleSelection: true,
      text: 'Please Select',
      enableFilterSelectAll: false,
      enableSearchFilter: true,
      classes: 'dropdown',
      primaryKey: 'eligible_bank_account',
      maxHeight: 170,
      labelKey: 'eligible_bank_account',
      noDataLabel: '',
      showCheckbox: false
    };

    // For update deposit
    this.paymentAccountDropdownSettings = {
      singleSelection: true,
      text: 'Please Select',
      enableFilterSelectAll: false,
      enableSearchFilter: true,
      classes: 'dropdown',
      primaryKey: 'value',
      maxHeight: 170,
      labelKey: 'payment_account',
      noDataLabel: '',
      showCheckbox: false
    };

    this.paymentModeDropdownSettings = {
      singleSelection: true,
      text: 'Please Select',
      enableFilterSelectAll: false,
      enableSearchFilter: true,
      classes: 'dropdown',
      primaryKey: 'id',
      maxHeight: 170,
      labelKey: 'name',
      noDataLabel: '',
      showCheckbox: false
    };

    this.eligiblePaymentProcessorDropdownSettings = {
      singleSelection: true,
      text: 'Please Select',
      enableFilterSelectAll: false,
      enableSearchFilter: true,
      classes: 'dropdown',
      primaryKey: 'gateway_id',
      maxHeight: 170,
      labelKey: 'eligible_payment_processor',
      noDataLabel: '',
      showCheckbox: false
    };

    this.eligibleBankDropdownSettings = {
      singleSelection: true,
      text: 'Please Select',
      enableFilterSelectAll: false,
      enableSearchFilter: true,
      classes: 'dropdown',
      primaryKey: 'id',
      maxHeight: 170,
      labelKey: 'name',
      noDataLabel: '',
      showCheckbox: false
    };

    this.eligibleCombinedDropdownSettings = {
      singleSelection: true,
      text: 'Please Select',
      enableFilterSelectAll: false,
      enableSearchFilter: true,
      classes: 'dropdown',
      primaryKey: 'label',
      maxHeight: 170,
      labelKey: 'label',
      noDataLabel: '',
      showCheckbox: false
    };

    this.dropdownSettings = {
      singleSelection: true,
      text: 'Please Select',
      enableFilterSelectAll: false,
      enableSearchFilter: true,
      classes: 'dropdown',
      primaryKey: 'labelKey',
      labelKey: 'username',
      maxHeight: 200,
      lazyLoading: true,
      noDataLabel: '',
      showCheckbox: false
    };

    const apSub = this.appPermissionService.getAppPermissions().subscribe(appPermissions => {
      const isCrypto = this.data.deposit?.is_crypto === 1;

      this.canEditDeposits = isCrypto ? appPermissions.edit_crypto_deposits : appPermissions.edit_deposits;
      this.canVoidDepositsBankTransaction = isCrypto ? appPermissions.void_crypto_deposits : appPermissions.void_deposits_bank_transactions;
      this.canVoidDepositsPaymentGateway = isCrypto ? appPermissions.void_crypto_deposits : appPermissions.void_deposits_payment_gateway;
      this.canRevertDeposits = isCrypto ? false : appPermissions.revert_deposits;
      this.canResolveUnusualCallback = isCrypto ? false : appPermissions.resolve_unusual_callback_deposit;
      this.canViewReceipts = isCrypto ? false : appPermissions.view_deposit_receipts;
      this.canRequestReceipts = isCrypto ? false : appPermissions.request_receipts;
      this.canUploadReceipts = isCrypto ? false : appPermissions.upload_receipts;
      this.canBrowseReceipts = isCrypto ? false : appPermissions.browse_receipts;
      this.canBypassBankingDepositLimit = isCrypto ? false : appPermissions.bypass_banking_deposit_limit;
      this.canViewDepositEventHistory = isCrypto ? false : appPermissions.view_deposit_event_history;
      this.canForceApproveDeposits = isCrypto ? false : appPermissions.force_approve_deposits;
      this.canManualResolveDeposit = isCrypto ? false : appPermissions.manual_resolve_deposit_transaction;

      this.cdr.detectChanges();

    });

    this.subscriptions.add(apSub);
  }

  ngOnDestroy() {
    this.datePickerSubscription.unsubscribe();
    this.subscription.unsubscribe();
    this.subscriptions.unsubscribe();
    this.formSubscription.unsubscribe();
    this.messageSubscription.unsubscribe();
    this.onRefresh();
  }

  ngAfterViewInit() {
    if (this.data.mode === 'create') {
      this.datePickerSubscription = forkJoin([
        this.buildDatePicker(0, 'datetime'),
      ]).subscribe();
    }
  }

  onViewMoreRemarks(data: any) {
    this.memberDataService.getRemarksHistory(data.member_id).subscribe(res => {
      this.openDialogBy(MemberRemarksListComponent, { remarks: res });
    });
  }

  onDisableBrowse(method: string) {
    return method.includes('Payment Gateway');
  }

  openReceipt() {
    let depositData = {
      ...this.data.deposit
    };
    depositData.receipts = this.depositReceipts;

    this.openDialogBy(ViewReceiptComponent, { deposit: depositData });
  }

  requestReceipt() {
    if (this.data.deposit.status === 7) {
      Swal.fire({
        icon: "error",
        title: 'System Message',
        text: 'Receipt already requested'
      });
      return;
    }

    const requestReceiptDialogRef = this.dialog.open(RequestReceiptDialogComponent, {
      width: "800px",
      data: {
        deposit: this.data.deposit,
      },
    });

    requestReceiptDialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.dialogRef.close(true);
      }
    });
  }

  onUpdateSelectedReceipt(data: any) {
    this.selectedReceipt$.next(data);
    this.onFocusField();
  }

  onCloseDialog(event?: Event) {
    this.dialogRef.close();
  }

  onGetTransactionCallbackLogs(page = 1, pageSize?: number) {
    pageSize = this.pageSize;
    const params = `&reference=${this.data.deposit.pg_reference_id}`;
    this.transactionCallbackHttpService.getCallbackLogs(`?page=${page}&perPage=${pageSize}${params}`).pipe(
      tap((res: any) => {
        this.transactionCallbackLogsPagination = res.paginations;
        this.transactionCallbackLogs = res.rows;
      })
    ).subscribe();
  }

  onVoid(deposit: Deposit) {
    if (
      (this.isBankTransfer() && !this.canVoidDepositsBankTransaction) ||
      (!this.isBankTransfer() && !this.canVoidDepositsPaymentGateway)
    ) {
      Swal.fire({
        icon: "error",
        title: 'Permission Denied',
        text: 'You do not have permission to void deposit'
      });
      return;
    }

    const amount = this.form.get('confirmed_amount').value;

    this.buttonLoading = true;

    this.depositDataService.checkWalletBalance(`member_account_id=${deposit.member_id}&amount=${amount}`).pipe(
      tap(res => {
        if (res.success) {
          this.onSave(deposit, 'void');
        }
      }),
      catchError(err => {
        this.buttonLoading = false;
        throw err;
      })
    ).subscribe();

  }

  onApproveClick(deposit: Deposit) {
    if (this.depositStatus === DepositStatus.PendingCallback && deposit.payment_gateway_id !== 0) {
      const dialogRef = this.dialog.open(DepositApproveComponent, {
        width: '800px',
        data: {
          id: deposit.id,
          deposit: deposit,
          mode: 'approve'
        }
      });

      // Listen to component's messages$ stream to display success message via kt-swal-alert (matching BO design)
      const componentInstance = dialogRef.componentInstance as DepositApproveComponent;
      const messagesSubscription = componentInstance.messages$.subscribe((messages: any) => {
        if (this.messages$ && messages) {
          this.messages$.next(messages);
        }
      });

      dialogRef.afterClosed().subscribe((result) => {
        messagesSubscription.unsubscribe();
        if (result) {
          this.dialogRef.close(true);
        }
      });
    } else {
      this.onSave(deposit, 'approve');
    }
  }

  onSave(deposit: Deposit, type: OnSaveDepositActionType, mode?: string) {
    if (!this.canEditDeposits) {
      Swal.fire({
        icon: "error",
        title: 'Permission Denied',
        text: 'You do not have permission to edit deposit'
      });
      return;
    }

    this.timezone = JSON.parse(localStorage.getItem('user_data')).timezone;
    this.offset = moment.tz(this.timezone).utcOffset() * 60 * 1000;
    this.checkValidation = true;
    if (this.form.valid) {
      this.buttonLoading = true;
      this.subscription = this.depositEntityService.getByIdNew(deposit.id).pipe(
        tap((res) => {

          if( type === 'force-approve' ) {
            if( res.last_callback_status !== true ) {
              Swal.fire({
                icon: 'error',
                title: 'Unable To Approve Deposit',
                text: 'The latest callback status indicates a different status. Please verify with the payment vendor before proceeding.',
              });
              this.buttonLoading = false;
              this.checkValidation = false;
              return;
            }
          }

          this.deposit.newBoUserId = res.bo_user_id;
          var bank_receipt_scan_time = sessionStorage.getItem('bank_receipt_scan_time');
          const data = {
            id: deposit ? deposit.id : null,
            bank_receipt_id: sessionStorage.getItem('bank_receipt_id'),
            bank_receipt_currency: sessionStorage.getItem('bank_receipt_currency'),
            bank_receipt_scan_time: bank_receipt_scan_time ? moment(new Date(bank_receipt_scan_time)).utc().format('YYYY-MM-DD HH:mm:ss') : null,
            ...this.form.value,
            status: (type === 'approve' || type === 'force-approve')
                      ? DepositStatus.Approved
                      : type === 'revert'
                      ? DepositStatus.PendingCallback
                      : (type === 'void' || type === 'reject')
                      ? DepositStatus.Rejected
                      : this.depositStatus,
            type,
          };

          if (type === 'mark-resolve') {
            data.unusual_callback = 0;
          }

          Object.keys(data).forEach((key) => (data[key] == null || data[key] === '') && delete data[key]);
          const showConfirmation = (title: string, text: string, icon?: 'warning') => {
            return Swal.fire({
              title,
              text,
              icon: 'info',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              reverseButtons: true
            });
          };
          const updateDeposit = (takeover = false) => {
            data.takeover = takeover;
            this.depositEntityService.updateNew(deposit.id, data).pipe(
              tap((row: any) => {
                if (row.success == false) {
                  Swal.fire({
                    icon: 'error',
                    title: row.message,
                  });
                } else {
                  this.messages$.next([...row.message]);
                }
                this.buttonLoading = false;
                this.checkValidation = false;
              }),
              catchError((error) => {
                this.buttonLoading = false;
                this.checkValidation = false;
                throw error;
              })
            ).subscribe();
          };

          let swalTitle, swalText = '';
          let remarksRequired = false;
          if (type === 'approve' || type === 'force-approve') {
            swalTitle = 'Approve Deposit';
            swalText = 'Do you want to approve this deposit?';
            if (this.depositStatus == DepositStatus.PendingReceipt) {
              remarksRequired = true;
              if (this.depositReceipts.length == 0) {
                swalText = 'There is no receipt uploaded for this deposit. Do you still want to approve the deposit?';
              }
            }
            if( type === 'force-approve' ) {
              remarksRequired = true;
            }
          }
          if (type === 'reject') {
            swalTitle = 'Reject Deposit';
            swalText = 'Do you want to reject this deposit?';
            remarksRequired = true;
            if (this.depositStatus == DepositStatus.PendingReceipt) {
              swalText = 'The <b>Request Receipt</b> action has been triggered. Do you want to proceed with rejecting the deposit?';
            }
          }
          if (type === 'void') {
            swalTitle = 'Void Approved Deposit';
            swalText = 'Do you want to reject this deposit?';
            remarksRequired = true;
            if (this.depositStatus == DepositStatus.PendingReceipt) {
              swalText = 'The <b>Request Receipt</b> action has been triggered. Do you want to proceed with rejecting the deposit?';
            }
          }
          if (type === 'revert') {
            swalTitle = 'Revert Deposit Status';
            swalText = "Do you want to revert this deposit status to <b>'Pending Callback'</b>?";
            remarksRequired = true;
          }
          if (type === 'mark-resolve') {
            swalTitle = 'Mark as Resolve';
            swalText = 'Would you like to mark as resolve?';
            remarksRequired = true;
          }

          let remarksHtml = `<p style="color: ${remarksRequired ? 'red' : ''};">Remark${remarksRequired ? '' : ' (Optional)'}</p></div><input id="remark-input" class="form-control">`;

          Swal.fire({
            title: swalTitle,
            html: '<div style="text-align: center;">' + remarksHtml + '<p style="margin-top: 20px;">' + swalText + '</p></div>',
            icon: 'info',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            preConfirm: () => {
              const inputValue = (document.getElementById('remark-input') as HTMLInputElement)?.value ?? '';

              if (inputValue.trim() === '' && remarksRequired) {
                Swal.showValidationMessage('Remarks is required.');
                return false;
              }

              if (inputValue != '') {
                data.remarks = inputValue;
              }
              return true;
            }
          }).then((resp) => {
            if (resp.value) {
              if (type === 'approve' || type === 'force-approve') {
                this.subscription = this.hasBankReceipt(this.data.deposit.id)
                  .pipe(tap((bankReceiptId) => {
                    if (!bankReceiptId) {
                      showConfirmation(
                        'No bank receipt selected!',
                        'Are you sure you want to ' + type + ' this deposit without selecting a bank receipt?')
                        .then((result) => {
                          if (result.value) {
                            updateDeposit();
                          } else {
                            this.buttonLoading = false;
                            this.checkValidation = false;
                          }
                        });
                    } else {
                      updateDeposit();
                    }
                  }))
                  .subscribe();
              }

              if (type === 'reject' || type === 'void' || type === 'revert' || type === 'mark-resolve') {
                updateDeposit();
              }
            } else {
              this.buttonLoading = false;
              this.checkValidation = false;
            }
          });
        })).subscribe();
      this.refreshStatus = true;
    }
  }

  onUpdateRemarks() {
    const data = {
      id: this.data.deposit.id,
      ...this.form.value,
    };

    Object.keys(data).forEach((key) => (key !== 'remarks' && key !== 'id') && delete data[key]);
    this.depositDataService.updateRemarks(data).pipe(
      tap((row: any) => {
        this.messages$.next([...row.message]);
      })
    ).subscribe();
  }

  async onAdd() {
    this.checkValidation = true;
    if (this.form.valid) {
      this.buttonLoading = true;
      // To set "Save" button to disable (To prevent call API in multiple times when double click)
      this.form.setErrors({ 'invalid': true });

      const data = {
        ...this.form.value,
        datetime: moment(this.form.value.datetime).tz(this.timezone, true).utc().format('YYYY-MM-DD HH:mm:ss'),
      };

      // Display-only dropdown labels — not consumed by the API, and bank labels may
      // contain characters rejected by the API's special-character filter (e.g. '&')
      delete data.eligible_bank_account;
      delete data.eligible_payment_processor;
      delete data.eligible_bank;
      delete data.eligible_combined;

      Object.keys(data).forEach((key) => (data[key] == null || data[key] === '' || data[key] < 1) && delete data[key]);
 
      const fireDepositLimitBypassConfirmation = async (title: string, messageText: string): Promise<boolean> => {
        const result = await Swal.fire({
          title,
          html: `${messageText} <br> Do you want to proceed with the deposit creation?`,
          icon: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          cancelButtonText: 'Cancel',
          confirmButtonText: 'Bypass Limit',
          reverseButtons: true,
        });
        return result.isConfirmed;
      };

      const validateAndPrompt = async (): Promise<boolean> => {
        // Min-Max Validation
        let minMaxValidation = this.validateMinMaxPerTransactionAmount(data['amount']);
        // Daily Count Validation
        let dailyCountValidation = (this.depositLimit.total_deposit_count_today >= this.depositLimit.daily_max_count && this.depositLimit.daily_max_count != 0) ? true : false;
        // Daily Max Validation
        let dailyMaxValidation = this.validateDailyMaxAmount(data['amount']);

        if (minMaxValidation || dailyCountValidation || dailyMaxValidation) {
          let messageText = '<div class="text-container deposit-limit-error" style="display: flex; justify-content: center; align-items: center; text-align: left;"><ul style="list-style: disc inside; padding: 0; margin: 0; max-width: 300px; word-wrap: break-word;">';
          if (dailyCountValidation) {
            messageText += '<li class="d-flex align-items-center"><i class="fas fa-info-circle mr-2"></i>' + 'Daily count : ' + this.depositLimit.daily_max_count + '</li>';
          }
          if (minMaxValidation) {
            messageText += '<li class="d-flex align-items-center"><i class="fas fa-info-circle mr-2"></i>';
            if (this.validateMinMaxPerTransactionAmount(data['amount'], 'checkMin')) {
              messageText += 'Minimum Amount : ' + this.depositLimit.currency_code + ' ' + this.depositLimit.min;
            } else if (this.validateMinMaxPerTransactionAmount(data['amount'], 'checkMax')) {
              messageText += 'Maximum Amount : ' + this.depositLimit.currency_code + ' ' + this.depositLimit.max;
            }
            messageText += '</li>';
          }
          if (dailyMaxValidation) {
            messageText += '<li class="d-flex align-items-center"><i class="fas fa-info-circle mr-2"></i>' + 'Daily Maximum : ' + this.depositLimit.currency_code + ' ' + this.depositLimit.daily_max + '</li>';
          }
          messageText += "</ul></div>"
          if (this.canBypassBankingDepositLimit) {
            const res = await fireDepositLimitBypassConfirmation('Invalid Transaction Amount', messageText);
            if (!res) return false;
          } else {
            await Swal.fire({
                title: 'Invalid Transaction Amount',
                html: `${messageText}`,
                icon: 'error',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok',
              });
              return false;
          }
        }
  
        return true;
      };
      
      const isValidationPassed = await validateAndPrompt();
      if (isValidationPassed) {
        this.handleDeposit(data);
      } else {
        this.form.setErrors(null);
        this.buttonLoading = false;
        this.checkValidation = false;
      }
      
      
      // this.messageSubscription = this.depositDataService.messages$.subscribe(message => {
      //   if (message.length > 0) {
      //     this.messages$.next([...message]);
      //     this.buttonLoading = false;
      //   }
      // });
    }
    this.refreshStatus = true;
  }

  handleDeposit(data: any) {
    this.subscription = forkJoin([
      this.depositEntityService.addNew(data).pipe(
        tap((res: any) => {
          this.messages$.next([...res.message]);
          this.form.setErrors(null);
          this.buttonLoading = false;
          this.checkValidation = false;
        }),
        catchError((error) => {
          this.form.setErrors(null);
          this.buttonLoading = false;
          this.checkValidation = false;
          throw error;
        })
      )
    ]).subscribe();
  }

  onRefresh() {
    if (this.refreshStatus === true) {
      this.dialogRef.close(true);
    }
  }

  onUploadFile(event: any) {
    const file: File = event.target.files[0];
    const formData = new FormData();
    formData.append('files', file, file.name);
    formData.append('type', 'receipts');
    this.uploadService.upload(formData).subscribe(res => {
      this.imagePreview = res;
      this.form.patchValue({
        receipt_path: this.imagePreview[0]
      });
      this.form.get('receipt_path').markAsDirty();
      this.form.markAllAsTouched();
      this.onFocusField();
    });
  }

  onFocusField() {
    of(null).pipe(
      delay(0), tap(() => this.focusfield.first.nativeElement.focus()
      )).subscribe();
  }

  isValidDate(date: Date | string) {
    if (moment(date).isValid()) {
      return moment(date).tz(this.timezone, true).utc().format('YYYY-MM-DD HH:mm');
    }
    return '-';
  }

  onShowBankReceiptBrowser() {
    if (typeof (this.form.value.payment_account_details) === 'string') {
      this.accountName = this.data.deposit.account_name;
      this.accountNumber = this.data.deposit.account_number;
      this.bankName = this.data.deposit.payment_option_name;
    }
    else {
      this.accountName = this.form.value.payment_account_details[2];
      this.accountNumber = this.form.value.payment_account_details[3];
      this.bankName = this.form.value.payment_account_details[1];
    }
    this.dialog.open(BankReceiptBrowserDialogComponent, {
      width: '1150px',
      data: {
        merchantBankDetails: this.paymentAccount.account_number ? this.paymentAccount : {
          account_name: this.accountName,
          account_number: this.accountNumber,
          bank_name: this.bankName
        },
        depositDetails: this.data.deposit
      }
    });
  }

  searchChange(event?: Event) {
    this.count = 0;
    this.searchTerm.next(String(event));
    this.searchTerm.pipe(
      distinctUntilChanged(),
      debounceTime(500),
    ).subscribe(res => {
      this.searchTerm = new Subject<string>();
      this.count++;
      if (this.count + 1 === res.length) {
        this.username = res;
      }
    });
  }

  onSelectMerchantBank(bankID: number) {
    const bankId = bankID;
    this.isSelectedMerchantBank = bankId ? true : false;
    this.onUpdateSelectedReceipt(null);
    if (bankId) {
      const paymentAccountData = this.paymentModeDataService.getPaymentAccountById(bankId);
      this.subscription = paymentAccountData.pipe(
        tap((res) => {
          if (
            (this.paymentAccount.account_number == '6377022783377613' && this.paymentAccount.account_name == 'CHONG SUN SENG') &&
            (res.bank_code != 'MAYP' && res.account_number != '6377022783377613' && res.account_name != 'CHONG SUN SENG')
          ) {
            Swal.fire({
              icon: 'info',
              title: 'System Message',
              text: 'You are switching from MatchMove to another bank account. Please note the processing fee.',
            });
          } else if (res.bank_code == 'MAYP' && res.account_number == '6377022783377613' && res.account_name == 'CHONG SUN SENG') {
            let processing_fee = (+this.data.deposit.amount * 0.03) + 1;
            this.form.patchValue({
              total_processing_fee: processing_fee,
              processing_fee: processing_fee,
              member_processing_fee: 0,
            });
          }

          this.paymentAccount.bank_name = res.bank_name;
          this.paymentAccount.account_number = res.account_number;
          this.paymentAccount.account_name = res.account_name;
          this.form.patchValue({
            account_name: res.account_name,
            account_number: res.account_number,
            merchant_bank_account: res.bank_code + " - " + res.account_name + " - " + res.account_number,
            payment_account_id: bankID,
            bank_code: res.bank_code
          });
        })).subscribe();
    } else {
      this.paymentAccount.bank_name = null;
      this.paymentAccount.account_number = null;
      this.paymentAccount.account_name = null;
      this.form.patchValue({
        account_name: null,
        account_number: null,
        merchant_bank_account: null,
        paymeny_account_id: null,
        bank_code: null
      });
    }
  }

  async onSelectedMemberChanged(value) {
    this.selectedMember = value;

    await this.onGetLimit();               
    await this.onGetPaymentMode(); 
  }

  /**
   * For this we will directly match payment_method (name) provided in data.deposit.
   * As long as payment_method contains the word "Bank Transfer" then we will consider
   * this deposit a bank transfer
   *
   */
  isBankTransfer() {
    const paymentAccountExists = this.data.deposit?.payment_account_id

    if (paymentAccountExists != null) {
      return true;
    }

    return false;
  }

  // Fee is read-only ONLY for true bank-transfer deposits — matches the backend guard
  // (merchant bank method == METHOD_BANK_TRANSFER). isBankTransfer() keys on payment_account_id, which
  // is also set for Ewallet/PayID; those are operator-editable server-side, so the fee readonly must NOT
  // lock them. payment_mode is the payment-method name shown in the UI ("Bank Transfer"), so match on it.
  isBankTransferFee(): boolean {
    const paymentMode: string = (this.data.deposit as any)?.payment_mode || '';
    if (!paymentMode) {
      return false;
    }
    const regex = new RegExp('Bank Transfer'.split(' ').join('.*'), 'i');
    return regex.test(paymentMode);
  }

  onSelectedMerchantBankChanged(value) {
    if (value.length > 0) {
      this.form.patchValue({
        payment_account_id: value[0].payment_account_id
      });
      this.onGetLimit(value[0].payment_account_id);
    } else {
      this.form.patchValue({
        payment_account_id: null
      });
    }
  }

  onSelectedPaymentProcessorChanged(value) {
    // Reset bank selection whenever the payment processor changes
    this.bankSelectedItems = [];
    this.form.patchValue({ eligible_bank: null, payment_option_code: null });

    if (value.length > 0) {
      this.form.patchValue({
        payment_gateway_config_id: value[0].gateway_id,
        payment_processor_id: value[0].processor_id
      });

      // Populate the Banks dropdown from the chosen processor's eligible payment options
      this.bankDropdownList = value[0].eligible_payment_options || [];

      this.onGetLimit(null, value[0].configuration_id);
    } else {
      this.bankDropdownList = [];
      this.form.patchValue({
        payment_gateway_config_id: null,
        payment_processor_id: null
      });
    }
  }

  onSelectedBankChanged(value) {
    if (value.length > 0) {
      this.form.patchValue({
        payment_option_code: value[0].code
      });
    } else {
      this.form.patchValue({
        payment_option_code: null
      });
    }
  }

  onSelectedCombinedChanged(value) {
    if (value.length > 0) {
      const selected = value[0];

      if (selected.type === 'DT') {
        this.form.patchValue({
          payment_account_id: selected.payment_account_id,
          payment_processor_id: null,
          payment_gateway_config_id: null
        });

        this.uploadReceipt = true;
        this.form.get('payment_account_id').setValidators(Validators.required);
        this.form.get('receipt_path').setValidators(Validators.required);

        this.form.get('payment_gateway_config_id').setValidators(null);
        this.form.get('payment_processor_id').setValidators(null);
        this.updateAllValidators();

        this.onGetLimit(selected.payment_account_id);
      }
      if (selected.type === 'PG') {
        this.form.patchValue({
          payment_account_id: null,
          payment_processor_id: selected.payment_processor_id,
          payment_gateway_config_id: selected.payment_gateway_config_id
        });

        this.uploadReceipt = false;
        this.form.get('payment_gateway_config_id').setValidators(Validators.required);
        this.form.get('payment_processor_id').setValidators(Validators.required);

        this.form.get('payment_account_id').setValidators(null);
        this.form.get('receipt_path').setValidators(null);
        this.updateAllValidators();

        this.onGetLimit(null, selected.configuration_id);
      }
    } else {
      this.uploadReceipt = false;
      this.resetFormValues();
    }
  }

  onSelectedPaymentModeChanged(value) {
    if (value.length > 0) {
      this.form.patchValue({
        payment_mode_id: value[0].id,
      });

      const processorTypes = value[0].processor_type.split(',').map(x => x.trim());
      const hasDT = processorTypes.includes('DT');
      const hasPG = processorTypes.includes('PG');

      if (hasDT && !hasPG) {
        // Only DT
        this.isDirectTransfer = true;
        this.isPG = false;
        this.isCombined = false;
        this.handleDT(value[0]);
      } else if (!hasDT && hasPG) {
        // Only PG
        this.isDirectTransfer = false;
        this.isCombined = false;
        this.isPG = true;
        this.handlePG(value[0]);
      } else if (hasDT && hasPG) {
        // Both DT + PG
        this.isCombined = true;
        this.isDirectTransfer = false;
        this.isPG = false;
        this.handleDTandPG(value[0]);
      } 
    } else {
      this.isDirectTransfer = false;
      this.isPG = false;

      this.form.patchValue({
        payment_mode_id: null,
        payment_account_id: null,
        payment_processor_id: null,
        payment_gateway_config_id: null
      });
    }
  }

  handleDT(paymentMode) {
    this.paymentAccountSelectedItems = [];
    this.resetFormValues();

    this.form.get('payment_account_id').setValidators(Validators.required);
    this.form.get('receipt_path').setValidators(Validators.required);

    this.form.get('payment_gateway_config_id').setValidators(null);
    this.form.get('payment_processor_id').setValidators(null);
    this.form.get('eligible_bank').setValidators(null);
    this.updateAllValidators();

    this.bankAccountLoading = true;
    this.paymentModeDataService
      .getPaymentAccountList(`?member_account_id=${this.selectedMember[0]['id']}&payment_mode_id=${paymentMode.id}&payment_option_ids=${paymentMode.payment_option_ids_dt}`)
      .subscribe(res => {
        this.paymentAccountDropdownList = res;
        this.bankAccountLoading = false;
      });
  }

  handlePG(paymentMode) {
    this.paymentProcessorSelectedItems = [];
    this.bankSelectedItems = [];
    this.bankDropdownList = [];
    this.resetFormValues();

    this.form.get('payment_gateway_config_id').setValidators(Validators.required);
    this.form.get('payment_processor_id').setValidators(Validators.required);
    this.form.get('eligible_bank').setValidators(Validators.required);

    this.form.get('payment_account_id').setValidators(null);
    this.form.get('receipt_path').setValidators(null);
    this.updateAllValidators();

    this.paymentProcessorLoading = true;
    this.paymentModeDataService
      .getPaymentProcessorList(`?member_account_id=${this.selectedMember[0]['id']}&payment_mode_id=${paymentMode.id}&payment_option_ids=${paymentMode.payment_option_ids_pg}`)
      .subscribe(res => {
        this.paymentProcessorDropdownList = res;
        this.paymentProcessorLoading = false;
      });
  }

  handleDTandPG(paymentMode) {
    this.paymentAccountSelectedItems = [];
    this.paymentProcessorSelectedItems = [];
    this.resetFormValues();

    // DT validators
    this.form.get('payment_account_id').setValidators(Validators.required);
    this.form.get('receipt_path').setValidators(Validators.required);

    // PG validators
    this.form.get('payment_gateway_config_id').setValidators(Validators.required);
    this.form.get('payment_processor_id').setValidators(Validators.required);

    // Bank dropdown is only shown in PG-only mode, not in the combined DT+PG flow
    this.form.get('eligible_bank').setValidators(null);

    this.updateAllValidators();

    // Call APIs in parallel
    this.combinedLoading = true;

    forkJoin({
      dtAccounts: this.paymentModeDataService.getPaymentAccountList(
        `?member_account_id=${this.selectedMember[0].id}&payment_mode_id=${paymentMode.id}&payment_option_ids=${paymentMode.payment_option_ids_dt}`
      ),
      pgProcessors: this.paymentModeDataService.getPaymentProcessorList(
        `?member_account_id=${this.selectedMember[0].id}&payment_mode_id=${paymentMode.id}&payment_option_ids=${paymentMode.payment_option_ids_pg}`
      )
    }).subscribe(
      ({ dtAccounts, pgProcessors }) => {

        // Map DT accounts
        const dtList = dtAccounts.map(item => ({
          type: 'DT',
          label: `${item.eligible_bank_account}`,
          value: item,
          payment_account_id: item.payment_account_id
        }));

        // Map PG processors
        const pgList = pgProcessors.map(item => ({
          type: 'PG',
          label: `${item.eligible_payment_processor}`,
          value: item,
          payment_processor_id: item.processor_id,
          payment_gateway_config_id: item.gateway_id,
          configuration_id: item.configuration_id
          
        }));

        // Combine both into one dropdown list
        this.combinedDropdownList = [...dtList, ...pgList];

        // Stop loading
        this.combinedLoading = false;
      },
      error => {
        console.error('Failed to load DT or PG', error);
        this.combinedLoading = false;
      }
    );
  }

  resetFormValues() {
    this.form.patchValue({
      payment_account_id: null,
      payment_gateway_config_id: null,
      payment_processor_id: null,
      eligible_bank: null,
      payment_option_code: null,
      receipt_path: null
    });
  }

  updateAllValidators() {
    this.form.get('payment_account_id').updateValueAndValidity();
    this.form.get('payment_gateway_config_id').updateValueAndValidity();
    this.form.get('payment_processor_id').updateValueAndValidity();
    this.form.get('eligible_bank').updateValueAndValidity();
    this.form.get('receipt_path').updateValueAndValidity();
  }

  onGetLimit(paymentAccountId?: number, configurationId?: number): Promise<any> {
    this.depositLimit = null;

    let path = `?member_account_id=${this.selectedMember[0]['id']}`;

    if (paymentAccountId) {
      path += `&payment_account_id=${paymentAccountId}`;
    }

    if (configurationId) {
      path += `&payment_processor_configuration_id=${configurationId}`;
    }

    return this.depositDataService.getLimitNew(path).toPromise().then(res => {
        this.depositLimit = res;
    });
  }

  onGetPaymentMode(): Promise<any> {
    this.paymentModeLoading = true;
    return this.paymentModeDataService.getPaymentModeList(`?member_account_id=${this.selectedMember[0]['id']}`)
      .toPromise()
      .then(res => {
        this.paymentModeDropdownList = res;
        this.paymentModeLoading = false;
      });
  }

  private openDialogBy(componentRef: any, data?: { remarks?: any, deposit?: any }) {
    this.dialog.open(componentRef, {
      width: '100rem',
      data: {
        remarks: data.remarks,
        deposit: data.deposit,
      }
    });
  }

  private buildDatePicker(index: number, formKey: string) {
    if (this.data.mode === 'create') {
      return this.datePicker.valueChange.pipe(
        map(res => this.datePipe.transform(res, this.transactionHttpService.dateTimeFormat)),
        tap(date => {
          this.form.patchValue({ [formKey]: date });
        }),
      );
    }
  }

  private hasBankReceipt(id: number) {
    return of(sessionStorage.getItem('bank_receipt_id'));
  }

  private bankReceiptInit(id: number) {
    this.subscription = this.bankReceiptDataService.getReceipt(id).pipe(
      tap(res => {
        this.bankReceiptDataService.selectedReceipt$.next(res);
        this.selectedReceipt$.next(res);
        if (res.length > 0) {
          sessionStorage.setItem('bank_receipt_id', res[0].id.toString());
          sessionStorage.setItem('bank_receipt_currency', res[0].currency);
          sessionStorage.setItem('bank_receipt_scan_time', res[0].created_at.toString());
        }
      })
    ).subscribe();
  }

  private formInit() {
    let paymentAccountAccountName = null;
    let paymentAccountAccountNumber = null;
    let paymentAccountID = null;
    let paymentOptionName = null;
    let paymentOptionCode = null;
    let merchantBankAccount = null;
    
    let confirmedAmount = null;
    let cr_confirmedAmount = null;

    let memberId = null;
    // let processingFee = null;
    let totalProcessingFee = 0;
    let processingFee = 0;
    let memberProcessingFee = 0;
    let cr_totalProcessingFee = 0;
    let cr_processingFee = 0;
    let cr_memberProcessingFee = 0;
    let remarks = null;
    let approvedAt = null;
    let createdAt = null;
    let receiptPath = null;
    let amount = null;
    const datetime = null;
    let status = 1;
    let pg_reference_id = null;
    let bank_code = null;
    let paymentProcessorID = null;
    let paymentGatewayConfigID = null;

    if (this.data.mode === 'edit') {
      this.depositStatus = this.depo.status === DepositStatus.Pending ? DepositStatus.InProgress : this.depo.status;

      paymentAccountID = this.data.deposit.payment_account_id;
      paymentOptionName = this.data.deposit.payment_option_name;
      paymentAccountAccountName = this.data.deposit.account_name;
      paymentAccountAccountNumber = this.data.deposit.account_number;
      merchantBankAccount = this.data.deposit.merchant_bank_account;

      paymentProcessorID = this.data.deposit.payment_processor_id;
      paymentGatewayConfigID = this.data.deposit.payment_gateway_config_id;

      confirmedAmount = this.data.deposit.confirmed_amount;
      cr_confirmedAmount = this.data.deposit.cr_confirmed_amount;

      // processingFee = this.data.deposit.processing_fee;
      processingFee = +this.data.deposit.processing_fee;
      memberProcessingFee = +this.data.deposit.member_processing_fee;
      totalProcessingFee = processingFee + memberProcessingFee;
      cr_processingFee = +this.data.deposit.cr_processing_fee;
      cr_memberProcessingFee = +this.data.deposit.cr_member_processing_fee;
      cr_totalProcessingFee = cr_processingFee + cr_memberProcessingFee;
      remarks = this.data.deposit.remarks;
      approvedAt = this.data.deposit.updated_at;
      createdAt = this.data.deposit.created_at;
      receiptPath = this.data.deposit.receipt_path;
      memberId = this.data.deposit.member_id;
      status = this.data.deposit.status;
      amount = this.data.deposit.amount;
      pg_reference_id = this.data.deposit.pg_reference_id;
      bank_code = this.data.deposit.bank_code

      this.form = new FormGroup({
        payment_account_id: new FormControl(paymentAccountID),
        payment_account_details: new FormControl([paymentAccountID, paymentOptionName, paymentAccountAccountName, paymentAccountAccountNumber]),
        account_name: new FormControl(paymentAccountAccountName),
        account_number: new FormControl(paymentAccountAccountNumber),
        merchant_bank_account: new FormControl(merchantBankAccount),
        total_processing_fee: new FormControl({ value: totalProcessingFee, disabled: [1, 2, 6].includes(this.data.deposit.status) }, [Validators.required, Validators.min(0), Validators.max(this.data.deposit.amount)]),
        processing_fee: new FormControl({ value: processingFee, disabled: [1, 2, 6].includes(this.data.deposit.status) }, [Validators.required, Validators.min(0)]),
        member_processing_fee: new FormControl({ value: memberProcessingFee, disabled: [1, 2, 6].includes(this.data.deposit.status) }, [Validators.required, Validators.min(0)]),
        cr_total_processing_fee: new FormControl(cr_totalProcessingFee, [Validators.required, Validators.min(0), Validators.max(this.data.deposit.cr_amount)]),
        cr_processing_fee: new FormControl(cr_processingFee, [Validators.required, Validators.min(0)]),
        cr_member_processing_fee: new FormControl(cr_memberProcessingFee, [Validators.required, Validators.min(0)]),
        confirmed_amount: new FormControl(confirmedAmount),
        cr_confirmed_amount: new FormControl(cr_confirmedAmount),
        remarks: new FormControl(remarks, [Validators.min(3)]),
        status: new FormControl(status),
        pg_reference_id: new FormControl({ value: pg_reference_id, disabled: (this.data.deposit.payment_gateway_id > 0 || [1,2,6].includes(this.data.deposit.status)) }),
        bank_code: new FormControl(bank_code),
        payment_processor_id: new FormControl(paymentProcessorID),
        payment_gateway_config_id: new FormControl(paymentGatewayConfigID),

        // Create form controls
        start_date: new FormControl()
      });

      this.paymentAccount.bank_name = paymentOptionName;
      this.paymentAccount.account_number = paymentAccountAccountNumber;
      this.paymentAccount.account_name = paymentAccountAccountName;

      if (this.paymentAccount != null)
        this.isSelectedMerchantBank = true;

      this.form.get('payment_account_details').valueChanges.subscribe(res => {
        if (this.selectedReceipt$.value != null && this.selectedReceipt$.value.length > 0) {
          this.selectReceiptAgain = true;
        } else {
          this.selectReceiptAgain = false;
        }
        this.onSelectMerchantBank(res ? res[0] : null);
        sessionStorage.removeItem('bank_receipt_id');
        sessionStorage.removeItem('bank_receipt_scan_time');
      });

      // Validate that the total processing fee should not be greater than the total deposit amount
      this.form.controls.total_processing_fee.valueChanges.subscribe(value => {
        this.validateProcessingFee('Local', value, +this.form.controls.processing_fee.value, +this.form.controls.member_processing_fee.value);
      })

      // Check if company + player greater than total, display message
      this.form.controls.processing_fee.valueChanges.subscribe(value => {
        this.validateProcessingFee('Local', +this.form.controls.total_processing_fee.value, value, +this.form.controls.member_processing_fee.value);
      });

      // Check if company + player greater than total, display message
      this.form.controls.member_processing_fee.valueChanges.subscribe(value => {
        this.validateProcessingFee('Local', +this.form.controls.total_processing_fee.value, +this.form.controls.processing_fee.value, value);
      });

      // Validate that the total processing fee should not be greater than the total deposit amount
      this.form.controls.cr_total_processing_fee.valueChanges.subscribe(value => {
        this.validateProcessingFee('Crypto', value, +this.form.controls.cr_processing_fee.value, +this.form.controls.cr_member_processing_fee.value);
      });

      // Check if company + player greater than total, display message
      this.form.controls.cr_processing_fee.valueChanges.subscribe(value => {
        this.validateProcessingFee('Crypto', +this.form.controls.cr_total_processing_fee.value, value, +this.form.controls.cr_member_processing_fee.value);
      });

      // Check if company + player greater than total, display message
      this.form.controls.cr_member_processing_fee.valueChanges.subscribe(value => {
        this.validateProcessingFee('Crypto', +this.form.controls.cr_total_processing_fee.value, +this.form.controls.cr_processing_fee.value, value);
      });
    }
    if (this.data.mode === 'create') {
      this.form = new FormGroup({
        member_account_id: new FormControl(null, [Validators.required]),
        eligible_bank_account: new FormControl(null),
        eligible_payment_processor: new FormControl(null),
        eligible_bank: new FormControl(null),
        payment_option_code: new FormControl(null),
        eligible_combined: new FormControl(null),
        payment_mode_id: new FormControl(null, [Validators.required]),
        payment_account_id: new FormControl(null),
        payment_gateway_config_id: new FormControl(null),
        payment_processor_id: new FormControl(null),
        amount: new FormControl(null, [Validators.required, Validators.pattern('^(?=.*[1-9])[0-9]+(\.[0-9]+)?$')]),
        datetime: new FormControl(datetime, [Validators.required]),
        receipt_path: new FormControl(receiptPath),
      });
    }
  }

  timezoneDateWithTimezone(date: any, timezone: any, format: any) {
    if (this.data.timezone) {
      let returnDate = this.timeZoneDate.transformWithTimezone(date, timezone, format);
      let todayDate = DateTime.now().setZone(timezone).toFormat('(ZZ)');
      todayDate = todayDate.replace('(', '(GMT ');
      returnDate = returnDate + ' ' + todayDate;
      return returnDate;
    }
    else {
      return this.timeZoneDate.transformWithTimezone(date, timezone, format);
    }
  }

  openUploadReceipt() {
    const dialogRef = this.dialog.open(UploadReceiptComponent, {
      width: '800px',
      data: {
        remarks: this.data.deposit.remarks,
        deposit: this.data.deposit,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getReceipts();
      if (result === true) {
        this.refreshStatus = true;
        this.dialogRef.close(true);
      }
    });
  }

  getReceipts() {
    this.depositDataService.getReceipt(this.data.deposit.id).pipe(
      map(res => {
        this.depositReceipts = res;
      })
    ).subscribe();
  }

  validateProcessingFee(type, total, company, player) {
    let totalProcessingFeeErrorMessage = '';
    let processingFeeErrorMessage = '';

    if (total < 0 || total > this.data.deposit.amount) {
      totalProcessingFeeErrorMessage = 'Total must be greater or equal to 0 and less than deposit amount';
      processingFeeErrorMessage = '';
    } else if (total !== (company + player)) {
      totalProcessingFeeErrorMessage = 'Total must be equal to Company + Player';
      processingFeeErrorMessage = 'Company + Player must be equal to Total';
    } else {
      totalProcessingFeeErrorMessage = '';
      processingFeeErrorMessage = '';
    }

    if (type == 'Crypto') {
      this.cr_totalProcessingFeeErrorMessage = totalProcessingFeeErrorMessage;
      this.cr_processingFeeErrorMessage = processingFeeErrorMessage;
    } else {
      this.totalProcessingFeeErrorMessage = totalProcessingFeeErrorMessage;
      this.processingFeeErrorMessage = processingFeeErrorMessage;
    }
  }

  validateMinMaxPerTransactionAmount(amount: number, type = null): boolean {
    const min = Number(this.depositLimit.min);
    const max = Number(this.depositLimit.max);

    if (type == 'checkMin') {
      return amount < min;
    } else if (type == 'checkMax') {
      return amount > max && max != 0;
    } else {
      return amount < min || (amount > max && max != 0)
    }
  }

  validateDailyMaxAmount(amount: number, type = null): boolean {
    const max = Number(this.depositLimit.daily_max);
    const total_deposit_today = Number(this.depositLimit.total_deposit_today);

    if (type == 'front' && (amount == 0 || amount == null)) {
      // Display as error when amount is equal on default
      return (total_deposit_today + amount >= max && max != 0);
    } else {
      return (total_deposit_today + amount > max && max != 0);
    }
  }

  getLighterColor(hex: string, percent: number = 30): string {
    if (!hex) return '#f7f8fa'; // Default to white if no color is provided
    hex = hex.replace('#', '');
  
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
  
    // Increase each channel value to make it lighter (but not exceed 255)
    r = Math.min(255, r + (255 - r) * (percent / 100));
    g = Math.min(255, g + (255 - g) * (percent / 100));
    b = Math.min(255, b + (255 - b) * (percent / 100));
  
    return `rgb(${r}, ${g}, ${b})`; // Return the lightened color
  }
}
